import styled from "styled-components";
import {CustomSelect} from "./CustomSelect";

interface Props {
    permission: string;
    description?: string;
    value: string;
    setPermission: (value: string) => void;
    possibleValues: string[];
}

const PermissionContainer = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    padding: 1rem;
    
    .permission-select {
        background-color: transparent;
        outline: none;
        border: none;
        font-size: 1.1rem;
        height: 2rem;
        margin: .2rem .5rem;
        padding: .2rem;
        color: #f2f2f2;
        border-bottom: #f2f2f2 solid 1px;
    }
    .permission-select-option {
        background-color: var(--content-box-bg);
        color: #f2f2f2;
        &:hover {
            background-color: var(--content-box-border);
        }
        &:focus {
            background-color: var(--content-box-border);
        }
        &:active {
            background-color: var(--content-box-border);
        }
    }
    .permission-name {
        margin: 0 0 .5rem 0;
    }
    &:hover {
        background-color: var(--content-box-hover);
    }
    .select-container {
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }
`;

export default function Permission({permission, description, value, setPermission, possibleValues}: Props) {

    return (
        <PermissionContainer>
            <div>
                <h1 className="permission-name">{permission}</h1>
                {description && <span className="permission-description"> - {description}</span>}
            </div>
            <div className={'select-container'}>
                <CustomSelect
                    value={value}
                    options={possibleValues}
                    onChange={setPermission}
                />
            </div>
        </PermissionContainer>
    );
}

